export const MySqlViewConfig = Symbol.for('drizzle:MySqlViewConfig');
